import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAccountStore = defineStore('adok-account', () => {
  const supportWidgetReady = ref(false)

  function markSupportWidgetReady() {
    supportWidgetReady.value = true
  }

  return { supportWidgetReady, markSupportWidgetReady }
})
